import { motion } from "framer-motion";
import {
  Waves,
  Flame,
  Droplets,
  Route,
  Gauge,
  ShowerHead,
  Cog,
  Hammer,
  ArrowUpRight,
} from "lucide-react";
import { useSiteContent, useSiteCopy, phoneHref } from "@/lib/siteContent";

export default function Services() {
  const { services: items, headings, owners } = useSiteContent();
  const { tx, href } = useSiteCopy();
  const icons = { Waves, Flame, Droplets, Route, Gauge, ShowerHead, Cog, Hammer };
  const services = items.map((s, i) => ({ ...s, desc: s.description, icon: icons[s.icon], span: i === 0 || i === items.length - 1 ? "lg:col-span-2" : "" }));
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="text-electric font-semibold tracking-[0.3em] text-sm uppercase mb-4" data-testid="services-eyebrow">{headings.services.eyebrow}</p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-tight chrome-text">
            {headings.services.title}
          </h2>
          <p className="mt-4 text-slate-400 max-w-xl font-light">
            {headings.services.description}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="services-grid">
          {services.map((s, i) => (
            <motion.a
              key={s.id}
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              href={href("service-action", "#request") || phoneHref(owners[0].phone)}
              aria-label={tx("service-action", s.title)}
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08 }}
              whileHover={{ y: -6 }}
              className={`group relative text-left metal-card rounded-2xl p-8 overflow-hidden ${s.span}`}
            >
              <div className="absolute top-0 left-0 h-[2px] w-0 bg-electric transition-all duration-500 group-hover:w-full" />
              <div className="flex items-start justify-between">
                <s.icon className="w-9 h-9 text-electric" strokeWidth={1.5} />
                <ArrowUpRight className="w-5 h-5 text-slate-600 group-hover:text-electric transition-colors duration-300" />
              </div>
              <h3 className="mt-6 font-bebas text-2xl tracking-wide text-white group-hover:text-electric transition-colors duration-300">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-slate-400 font-light leading-relaxed">{s.desc}</p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
